<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <DashboardHeader />
    <v-row
      v-if="certificates.length == 0 && !loadingData"
      align="center"
      class="mt-16"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-text="$t('emptyCertificatesPageText')"
          page-image="image2"
        />
      </v-col>
    </v-row>
    <v-row v-if="certificates.length > 0 && !loadingData">
      <v-col :cols="mobile() ? '12' : '11'" :class="mobile() ? '' : 'mx-auto'">
        <v-card elevation="0" class="pa-5 rounded-xxl">
          <v-row align="center" no-gutters>
            <v-col cols="12">
              <v-card-text class="pa-1">
                <v-row no-gutters>
                  <v-col cols="10" class="d-flex align-center">
                    <span class="text-body-1 font-weight-bold">{{
                      $t("title")
                    }}</span>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <span class="text-body-1 font-weight-bold">{{
                      $t("dateOfIssue")
                    }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
            <v-col
              cols="12"
              v-for="(item, index) in certificates"
              :key="item.id"
            >
              <v-card
                data-testid="certificate-card"
                :rounded="false"
                class="pa-1 elevation-0"
                @click="
                  item.workflow_action_id
                    ? downloadWorkflowCertificate(item.workflow_action_id, item.workflow.title)
                    : downloadActivityCertificate(
                        item.activity.uuid,
                        item.activity.title
                      )
                "
                :ripple="false"
              >
                <v-row no-gutters class="row-pointer">
                  <v-col cols="10" class="d-flex align-center">
                    <v-card-title
                      data-testid="certificate-title"
                      class="text-left no-break darktext--text text-body-1 pl-0"
                    >
                      <v-icon class="mr-2"> mdi-download </v-icon>
                      <v-clamp autoresize :max-lines="1">
                        {{
                          item.workflow_action_id
                            ? item.workflow.title
                            : item.activity.title
                        }}
                      </v-clamp>
                    </v-card-title>
                  </v-col>
                  <v-col cols="2" class="d-flex align-center">
                    <span data-testid="certificate-date">{{ format_date(item.created_at) }}</span>
                  </v-col>
                </v-row>
              </v-card>
              <v-divider v-if="index < certificates.length - 1"></v-divider>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </nav>
</template>

<script>
import i18n from "../../plugins/i18n";
import {
  getCertificates,
  getCeftificateCompletionDate,
} from "../../api/activityApi";
import { downloadWorkflowCertificate } from "../../api/workflowApi";
import { getSpaceByURL } from "../../api/spaceApi";
import VClamp from "vue-clamp";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
import AlertMessages from "../../components/AlertMessages";
import DashboardHeader from "../../components/DashboardHeader";
import jsPDF from "jspdf";
import moment from "moment";
import EmptyPage from "../../components/EmptyPage";

export default {
  components: {
    VClamp,
    AlertMessages,
    DashboardHeader,
    EmptyPage,
  },
  mixins: [repeatedMethodsMixin],

  data() {
    return {
      permissions: [],
      spaceId: window.$cookies.get("space_id"),
      alertMsg: "",
      alertType: "",
      alertValue: false,
      link: { title: "", route: "/activity/create" },
      loadingData: false,
      certificates: [],
    };
  },

  async created() {
    this.loadingData = true;
    await this.fetchCertificates();
    this.loadingData = false;
  },

  methods: {
    showhubPage() {
      this.$router.push({ path: "/all-hubs-participant" });
    },
    showActivityPage() {
      this.$router.push({ path: "/all-activities-participant" });
    },
    seeAll() {
      this.$router.push({ path: "/dashboard-participant" });
    },
    async fetchCertificates() {
      try {
        const response = await getCertificates(this.spaceId);
        if (response.status) {
          if (response.status == 200) {
            var activityCertificates = response.data.meta.activity_certificates;
            var workflowCertificates = response.data.meta.workflow_certificates;
            this.certificates =
              activityCertificates.concat(workflowCertificates);
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },

    async downloadWorkflowCertificate(workflowActionId, workflowTitle) {
      try {
        const response = await downloadWorkflowCertificate(workflowActionId);
        if (response.status) {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            let name = localStorage.user
            ? JSON.parse(localStorage.user).first_name +
              " " +
              JSON.parse(localStorage.user).last_name
            : "null";
            link.setAttribute("crossorigin", "anonymous");
            link.setAttribute("download", "Certificate_" + workflowTitle + "_" + name + ".pdf");
            document.body.appendChild(link);
            link.click();
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    async downloadActivityCertificate(activityId, activityTitle) {
      const response_date = await getCeftificateCompletionDate(activityId);
      await this.getSpace();
      var newLogo = this.space.logo;
      var newSubdomain = this.space.subdomain;
      var logo = newLogo
        ? (logo = newLogo + "?notfromcache")
        : (logo = require("../../assets/rtplogo.svg"));
      let name = localStorage.user
        ? JSON.parse(localStorage.user).first_name +
          " " +
          JSON.parse(localStorage.user).last_name
        : "null";
      let domain = newSubdomain
        ? newSubdomain + "." + process.env.VUE_APP_DOMAIN
        : process.env.VUE_APP_DOMAIN;
      if (name && name != " " && logo && activityTitle) {
        var RobotoFont = require("../../components/RobotoFont");
        var robotoFont = new RobotoFont.RobotoFont();
        var font = robotoFont.getFont();
        var callAddFont = function () {
          this.addFileToVFS("Roboto-Regular-normal.ttf", font);
          this.addFont("Roboto-Regular-normal.ttf", "Roboto-Regular", "normal");
        };
        jsPDF.API.events.push(["addFonts", callAddFont]);

        var doc = new jsPDF();
        let pdfName = "Certificate_" + activityTitle + "_" + name;

        var width = doc.internal.pageSize.getWidth();
        let pageHeight = doc.internal.pageSize.getHeight();

        let certificateTextPart1 = i18n.t("certificateTextPart1");
        let certificateTextPart2 = i18n.t("certificateTextPart2");
        let certificateTextPart3 = i18n.t("certificateTextPart3");
        let certificateTextDate = i18n.t("certificateTextDate");

        doc.setFont("Roboto-Regular", "normal");
        doc.setTextColor(0, 0, 0, 0.8);
        doc.setFontSize(16);
        doc.text(certificateTextPart1, width / 2, 80, {
          align: "center",
          maxWidth: width - 30,
        });
        doc.setFontSize(22);
        doc.text(name, width / 2, 100, {
          align: "center",
          maxWidth: width - 30,
        });
        doc.setFontSize(16);
        doc.text(certificateTextPart2, width / 2, 120, {
          align: "center",
          maxWidth: width - 30,
        });
        doc.setFontSize(22);
        doc.text(activityTitle, width / 2, 140, {
          align: "center",
          maxWidth: width - 30,
        });
        doc.setFontSize(16);
        doc.text(certificateTextPart3, width / 2, 170, {
          align: "center",
          maxWidth: width - 30,
        });
        doc.text(
          certificateTextDate +
            ": " +
            response_date.data.data[0].attributes.created_at.slice(0, 10),
          width / 2,
          230,
          { align: "center", maxWidth: width - 30 }
        );
        doc.text(domain, width / 2, pageHeight - 20, {
          align: "center",
          maxWidth: width - 30,
        });

        if (logo.split(/[#?]/)[0].split(".").pop().trim() == "svg") {
          var XMLrequest = new XMLHttpRequest(); // new XML request
          XMLrequest.crossOrigin = "anonymous";
          XMLrequest.open("GET", logo, false); // URL of the SVG file on server
          XMLrequest.send(null); // get the SVG file

          var mySVG = XMLrequest.responseXML.getElementsByTagName("svg")[0];

          var svgString = new XMLSerializer().serializeToString(mySVG);

          var data = "data:image/svg+xml;utf8," + encodeURIComponent(svgString);

          var canvas = document.createElement("canvas");
          var svgwidth = mySVG.width.baseVal.value;
          var svgheight = mySVG.height.baseVal.value;
          canvas.width = svgwidth;
          canvas.height = svgheight;

          var ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          var img = new Image();
          img.src = data;

          img.onload = function () {
            let devide = this.height / 28;
            let imageWidth = this.width / devide;
            ctx.drawImage(img, 0, 0);
            var png = canvas.toDataURL("image/png");
            doc.addImage(png, width / 2 - imageWidth / 2, 20, imageWidth, 28);
            doc.save(pdfName + ".pdf");
          };
        } else if (
          logo.split(/[#?]/)[0].split(".").pop().trim() == "jpg" ||
          logo.split(/[#?]/)[0].split(".").pop().trim() == "jpeg" ||
          logo.split(/[#?]/)[0].split(".").pop().trim() == "png"
        ) {
          let img = new Image();
          img.src = logo;
          img.crossOrigin = "anonymous";

          img.onload = function () {
            let devide = this.height / 28;
            let imageWidth = this.width / devide;
            doc.addImage(this, width / 2 - imageWidth / 2, 20, imageWidth, 28);
            doc.save(pdfName + ".pdf");
          };
        }
      }
    },
    async getSpace() {
      if (!this.space) {
        try {
          const response = await getSpaceByURL(
            window.location.host.split(".")[0]
          );
          if (response.status == 200) {
            this.space = response.data.data.attributes;
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
  },
};
</script>
